<h2 mat-dialog-title i18n>Add Protected Resource</h2>
<mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign="start stretch">
    <mat-form-field>
      <mat-label i18n>Resource Name</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="data.name"
        matTooltip="A name for you to uniquely identify this resource"
      />
      <mat-icon class="form-icon" matSuffix>star</mat-icon>
    </mat-form-field>
    <mat-form-field>
      <mat-label i18n>Resource Type</mat-label>
      <mat-select [(value)]="data.resourceType">
        <mat-option [value]="resourceType.WindowsLogin">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <mat-icon color="primary" svgIcon="microsoft-windows"></mat-icon>
            <span i18n>Windows Login</span>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="center center"
  fxLayoutGap="15px"
>
  <button mat-button [mat-dialog-close]="data" i18n>Add</button>
</mat-dialog-actions>
